// When running on local.amplify.com values are from: {CKLA-Hub root dir}/public/amp-config.json
import EnvConstants, { isLocalEnvByUrl } from 'app/services/core/config.service'
import { HUB_BASE } from 'app/constants/routes.constants'
import { AmpConfig, EnvironmentFlags } from 'app/types/amp-config.types'

const ampConfig: AmpConfig = {}
const environmentFlags: EnvironmentFlags = {}
let ampConfigPromise: Promise<EnvironmentFlags> | null = null

const fetchAmpConfig = async () => {
  const baseUrl = isLocalEnvByUrl()
    ? `${window.location.origin}${HUB_BASE}`
    : `${EnvConstants.LEARNING_URL}`
  const ampConfigUrl = `${baseUrl}/amp-config.json`

  const res = await fetch(ampConfigUrl, {
    headers: {
      Accept: 'application/json',
    },
  })

  return res.json()
}

export const fetchEnvironmentFlags = () => {
  if (!ampConfigPromise) {
    ampConfigPromise = fetchAmpConfig().then((configJson) => {
      Object.assign(ampConfig, configJson)
      Object.assign(environmentFlags, configJson.flags)
      return environmentFlags
    })
  }
  return ampConfigPromise
}

export const getAmpConfig = () => ampConfig

export const isFeatureEnabled = (flag: string) =>
  environmentFlags['ckla-hub']?.[flag] ?? false
